module.exports = __webpack_public_path__ + "media/images/v2/lottie_support_background-a15af6e5f5c0866c8e6f5d37ef624c14.png";